export interface TextBoxProps {
  design: DesignType;
  body?: string;
}

export enum DesignType {
  regular = 'Regular',
  legalPage = 'Legal Page',
}
